var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{attrs:{"type":"border-card"}},[_c('el-tab-pane',{attrs:{"label":"投放计划"}},[_c('launch')],1),_c('el-tab-pane',{attrs:{"label":"广告"}},[_c('advertising')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }